import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import ProductSearch from '../components/product_search'
import Themed from 'store/v2/react/components/Themed'

const store = window.booqableStore

export default class ProductSearchContainer extends React.Component {
  static displayName = 'ProductSearchContainer'

  static propTypes = {
    searchKey: PropTypes.string
  }

  render = () => {
    return (
      <Provider store={store}>
        <Themed>
          <div className="booqable-component" style={{ display: 'none' }}>
            <ProductSearch {...this.props} filterKey={this.props.searchKey} />
          </div>
        </Themed>
      </Provider>
    )
  }
}
